module.exports = __webpack_public_path__ + "img/15.84df7e4e.jpg";